// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "79239180e2c9ede6044cfd294fc56425d139976d/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};